<!-- eslint-disable vue/no-v-html -->
<template>
  <TContainer class="my-24">
    <TGrid
      v-if="!isMetaDev"
      has-vertical-gap
    >
      <TGridItem :md="6">
        <div class="space-y-6">
          <LogoRvezy :class="{ 'lg:hidden': !isWebView }" />

          <THeading :level="2">
            {{ error.statusCode === 404 ? t('pages.error.title.fourOhFour') : t('pages.error.title.others') }}
          </THeading>
          <TSubHeading class="mt-2">
            {{ error.statusCode === 404 ? t('pages.error.body.fourOhFour') : t('pages.error.body.others') }}
          </TSubHeading>

          <ul>
            <li>
              <NuxtLink
                :to="localePath('index')"
                class="underline hover:no-underline text-secondary"
              >
                {{ t('pageLink.home') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="localePath('rv-search')"
                class="underline hover:no-underline text-secondary"
              >
                {{ t('pageLink.searchRVs') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="localePath('how-it-works')"
                class="underline hover:no-underline text-secondary"
              >
                {{ t('pageLink.howRVezyWorks') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="linkListRv"
                class="underline hover:no-underline text-secondary"
              >
                {{ t('pageLink.listAnRV') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="localePath('about')"
                class="underline hover:no-underline text-secondary"
              >
                {{ t('pageLink.aboutRVezy') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                :to="localePath('blog')"
                class="underline hover:no-underline text-secondary"
              >
                {{ t('pageLink.blog') }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </TGridItem>

      <TGridItem :md="6">
        <TImage
          fluid
          :src="image"
          :alt="t('pages.error.heroImageAlt')"
          :title="t('pages.error.heroImageAlt')"
          rounded
        />
      </TGridItem>
    </TGrid>
    <div
      v-else
      class="space-y-4"
    >
      <div>
        <THeading :level="1">
          Error {{ error.statusCode }}
        </THeading>

        <TSubHeading>{{ error.statusMessage }}</TSubHeading>
      </div>

      <pre
        class="bg-gray-50 p-4 rounded-md whitespace-pre-wrap"
        v-html="error.stack"
      />
      <pre class="bg-gray-50 p-4 rounded-md whitespace-pre-wrap">{{ error }}</pre>
    </div>
  </TContainer>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps<{
  error: NuxtError
}>()

const localePath = useLocalePath()
const { linkListRv } = useOwnerCommon()
const { isWebView } = usePlatform()

const { t } = useI18n()

const { getStaticImage, presets } = useImage()
const preset = presets.NATIVE_MD

const image = computed(() => getStaticImage({
  path: '/web-app/experience-blog/assets/images/lady-looking-into-sunset-on-deck_800x600.jpg',
  preset,
}))
</script>

<i18n src="~~/i18n/locales/common/pages/error.json" lang="json" />
